<div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
  <div class="container" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
    <h1 class="header">{{ 'EFolders.Folders' | translate }}</h1>
    <div class="content-card">
      <mat-tab-group #tab (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
        <mat-tab [label]="'EFolders.FoldersList' | translate" *hasPermission="['ViewWorkerAgreementsList']"> </mat-tab>
        <mat-tab [label]="'EFolders.DocumentsList' | translate"> </mat-tab>
      </mat-tab-group>
    </div>

    @switch (listType) {
      @case (listTypes.EFolders) {
        <app-e-folders-list></app-e-folders-list>
      }
      @case (listTypes.EDocuments) {
        <app-e-documents-list></app-e-documents-list>
      }
    }
  </div>
</div>
